import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { quotesApis } from "../utils/apis";
import {
  createAxiosInstanceOrder,
  orderManagementApiRequest,
} from "../utils/request";

export const createQuote = createAsyncThunk("createQuote", async (payload) => {
  try {
    const axiosInstance = createAxiosInstanceOrder();
    const response = await axiosInstance.post(quotesApis.createQuote, payload);
    return response.data;
  } catch (error) {
    if (error.response && error.response.status === 401) {
      localStorage.clear();
      window.location.replace("/");
    } else {
      throw new Error(error.response?.data?.detail || error.message);
    }
  }
});

export const updateQuoteStatus = createAsyncThunk(
  "updateQuoteStatus",
  async (payload) => {
    try {
      const axiosInstance = createAxiosInstanceOrder();
      const response = await axiosInstance.post(
        quotesApis.updateQuoteStatus,
        payload
      );
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.clear();
        window.location.replace("/");
      } else {
        throw new Error(error.response?.data?.detail || error.message);
      }
    }
  }
);

export const updateQuote = createAsyncThunk("updateQuote", async (payload) => {
  try {
    const axiosInstance = createAxiosInstanceOrder();
    const response = await axiosInstance.post(quotesApis.updateQuote, payload);
    return response.data;
  } catch (error) {
    if (error.response && error.response.status === 401) {
      localStorage.clear();
      window.location.replace("/");
    } else {
      throw new Error(error.response?.data?.detail || error.message);
    }
  }
});

export const listAllQuotes = createAsyncThunk(
  "listAllQuotes",
  async (payload) => {
    try {
      const axiosInstance = createAxiosInstanceOrder();
      const response = await axiosInstance.get(quotesApis.getAllQuotes);
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.clear();
        window.location.replace("/");
      } else {
        throw new Error(error.response?.data?.detail || error.message);
      }
    }
  }
);

export const getQuoteByID = createAsyncThunk(
  "getQuoteByID",
  async (payload) => {
    try {
      const axiosInstance = createAxiosInstanceOrder();
      const response = await axiosInstance.get(
        `${quotesApis.getQuoteById}/${payload}`
      );
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.clear();
        window.location.replace("/");
      } else {
        throw new Error(error.response?.data?.detail || error.message);
      }
    }
  }
);

export const getUpcLookupByUpc = createAsyncThunk(
  "getUpcLookupByUpc",
  async (payload) => {
    try {
      const axiosInstance = createAxiosInstanceOrder();
      const response = await axiosInstance.get(
        `${quotesApis.getUpcLookup}?upc=${payload?.upc}`
      );
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.clear();
        window.location.replace("/");
      } else {
        throw new Error(error.response?.data?.detail || error.message);
      }
    }
  }
);

const QuoteSlice = createSlice({
  name: "Quote",
  initialState: {
    quote: {},
  },
  extraReducers: (builder) => {
    builder
      .addCase(createQuote.pending, (state) => {
        state.loading = true;
      })
      .addCase(createQuote.fulfilled, (state, action) => {
        state.loading = false;
        state.quote = action.payload;
      })
      .addCase(createQuote.rejected, (state, action) => {
        state.loading = false;
      });
  },
});

export default QuoteSlice.reducer;
